import { useRouter } from "next/router";
import { useFlags } from "launchdarkly-react-client-sdk";
import { ClientRoutes, FeatureFlags } from "@common/constants";
import { useHousehold, useMeClient } from "@common/queries";
import useAdvisorStore from "@modules/advisor/state";
import { useGetClientEULA } from "@modules/eula/queries";
import { SERVICE_LINES_LAUNCH_DATE } from "./constants";
import useWhatsNewStore from "./state";

const useWhatsNewModalGate = () => {
  const router = useRouter();
  const flags = useFlags();
  const isFlagOn = Boolean(flags[FeatureFlags.SERVICE_LINE_PAGES]);
  const { data: client } = useMeClient();
  const { data: household } = useHousehold();
  const { data: eulaData } = useGetClientEULA();
  const { impersonateClientUserId } = useAdvisorStore();
  const hasDismissed = useWhatsNewStore((s) => s.hasDismissedServiceLinesIntro);
  const dismiss = useWhatsNewStore((s) => s.dismiss);

  const householdPredatesLaunch = household
    ? new Date(household.createdAt) < SERVICE_LINES_LAUNCH_DATE
    : false;

  const shouldOpen =
    isFlagOn &&
    !impersonateClientUserId &&
    Boolean(eulaData?.accepted_at) &&
    router.pathname === ClientRoutes.Overview &&
    client?.onboardingCompleted === true &&
    householdPredatesLaunch &&
    !hasDismissed;

  return { shouldOpen, dismiss };
};

export { useWhatsNewModalGate };
